import React, { useState } from "react";
import TeamService from "services/TeamService";
import { useTimelineContext } from "store/contexts/timelineContext";
import Button from "components/CustomButton";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useToasts } from "react-toast-notifications";
import { ReactComponent as CloseIcon } from "assets/img/icons/cancel.svg";
import CustomInput from "components/CustomInput/CustomInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusSquare } from "@fortawesome/free-solid-svg-icons";
import Loader from "components/Loader";
import { Modal } from "react-responsive-modal";
import { useTeamActionContext } from "store/contexts/teamActionContext";

export default ({ team }) => {
  const [dialogState, setDialogState] = useState(false);
  const [loading, setLoading] = useState(false);
  const { createTodo } = useTimelineContext();
  const { addToast } = useToasts();
  const { createNewPost } = useTeamActionContext();

  const formik = useFormik({
    initialValues: {
      list_name: "",
    },
    validationSchema: Yup.object().shape({
      list_name: Yup.string()
        .min(4, "List name must be between 4 to 100 characters.")
        .max(100, "List name must be between 4 to 100 characters.")
        .trim()
        .required("Please enter the list name."),
    }),
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const response = await TeamService.postCreateTodoList(team.id, {
          name: values.list_name,
        });

        formik.resetForm();

        var postData = {
          id: response.data.data.id,
          content: response.data.data.name,
        };

        createNewPost(
          postData,
          response.data.data.team_post_id,
          response.data.data.updated_at,
          { name: "todo-list", type_id: 16 }
        );
        createTodo(response.data.data);

        setLoading(false);
        setDialogState(false);

        addToast("Your list has been created successfully.", {
          appearance: "success",
        });
      } catch (e) {
        console.log(e);
        setLoading(false);
      }
    },
  });

  const closeDialog = () => {
    formik.resetForm();

    setDialogState(false);
  };

  return (
    <>
      <Button
        onClick={() => setDialogState(true)}
        buttonClass="light-gray-btn d-inline-block mb-3"
      >
        <FontAwesomeIcon icon={faPlusSquare} /> Create A List
      </Button>
      <Modal
        open={dialogState}
        onClose={closeDialog}
        showCloseIcon={false}
        classNames={{
          modalContainer: "modalContainer",
          modal: "listModal",
        }}
      >
        <div className="listModalContent">
          <h5 className="text-center listModalHeader">Add List Name</h5>
          <Button type="button" buttonClass="btn-close">
            <CloseIcon onClick={closeDialog} />
          </Button>
          <form noValidate onSubmit={formik.handleSubmit}>
            <CustomInput
              id={"add-members"}
              formGroup={false}
              inputClass="full_w listInput"
              inputProps={{
                type: "text",
                placeholder: "List Name",
                ...formik.getFieldProps("list_name"),
                error: formik.errors.list_name,
              }}
            />
            <Button
              buttonClass="btn grad_btn full_w"
              name={!loading ? "Create Now" : <Loader width={40} height={40} />}
              disabled={loading && true}
            />
          </form>
        </div>
      </Modal>
    </>
  );
};
